import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "development",
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // No tracing in local dev; 10% in production
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    // Replay only on errors, never for normal sessions
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request?.headers) {
        const sensitive = ["Authorization", "Cookie", "X-Auth-Token"];
        sensitive.forEach((h) => delete event.request!.headers![h]);
      }
      return event;
    },
  });
}
